import { IStampSettings } from "@mctypes/checklist.types";
import { Group, Stack, Text, ThemeIcon } from "@mantine/core";
import McInputNew from "../../../../components/McInput/McInputNew";

const StampConfiguration: React.FC<{
  currentConfig: IStampSettings;
  onChange: (newSettings: IStampSettings) => void;
}> = ({ currentConfig, onChange }) => {
  if (currentConfig == null) {
    return null;
  }

  const updateSettings = (key: keyof IStampSettings, value: string) => {
    onChange({
      ...currentConfig,
      [key]: {
        ...currentConfig[key],
        text: value,
      },
    });
  };

  return (
    <Stack gap="xs">
      <StampConfigurationRow
        label="OK"
        config={currentConfig.yes}
        required={true}
        onBlur={(value) => updateSettings("yes", value)}
      />
      <StampConfigurationRow
        label="Nei"
        config={currentConfig.no}
        required={true}
        onBlur={(value) => updateSettings("no", value)}
      />
      <StampConfigurationRow
        label="IR"
        config={currentConfig.ir}
        required={true}
        onBlur={(value) => updateSettings("ir", value)}
      />
      <StampConfigurationRow
        label="UAV"
        config={currentConfig.uav}
        required={false}
        onBlur={(value) => updateSettings("uav", value)}
      />
      <StampConfigurationRow
        label="NA"
        config={currentConfig.na}
        required={false}
        onBlur={(value) => updateSettings("na", value)}
      />
    </Stack>
  );
};

export default StampConfiguration;

const StampConfigurationRow: React.FC<{
  label: string;
  config: {
    text: string;
    color: string;
    icon: string;
  };
  required: boolean;
  onBlur: (value: string) => void;
}> = ({ label, config, required, onBlur }) => {
  return (
    <Group align="center" gap="xs" wrap="nowrap">
      <SingleStamp config={config} />
      <Text fw={500} miw={40}>
        {label}
      </Text>
      <McInputNew required={required} value={config.text} onBlur={(e) => onBlur(e.target.value)} />
    </Group>
  );
};

export const SingleStamp: React.FC<{
  config: {
    text: string;
    color: string;
    icon: string;
  };
}> = ({ config }) => {
  return (
    config != null && (
      <ThemeIcon radius="xl" size={25} c="#fff" style={{ backgroundColor: config.color }}>
        <i className={`fa fa-${config.icon}`} />
      </ThemeIcon>
    )
  );
};
